exports.RECAPTCHA_CLIENT_KEY_V2 = "6LcDxsUZAAAAAK5S5VojsfCQUQJuAnqMPF0dwr_x";
exports.RECAPTCHA_CLIENT_KEY_V3 = "6Lc1EVQaAAAAAOl_13gD2hpqfERCMAJ8bdrjV7dr";
